import React from "react";
import LiberacaoService from "../../services/LiberacaoService";
import CrudList from "../../components/forms/custom/CrudList";

export default class ListaLiberacao extends CrudList {

    constructor(props) {
        super(props);

        this.state.crud = {
            service: LiberacaoService,
            labels: {
                title: 'Lista de Liberação(ções)',
                btnNewRegister: 'Liberação',
            },
            keyItem: 'idLiberacao',
            urlForm: '/CadLiberacao',
            itensFilter: ["idLiberacao", "nome"],
            searchFormSubmit: false
        };
    }

    componentDidMount() {
        super.componentDidMount();
    }

    componentWillUnmount() {
        super.componentWillUnmount();
    }

    getRenderHeader() {
        return (
            <>
                <th className="text-center d-none d-md-table-cell"> Código </th>
                <th className="col-md-10"> Nome </th>
            </>
        );
    }

    getRenderItem(item) {
        return (
            <>
                <td className="text-center d-none d-md-table-cell">{item.idLiberacao}</td>
                <td>{item.nome}</td>
            </>);
    }

    render() {
        return super.render();
    }
}